import React from 'react';
import { useSelector } from "react-redux";
import {
  CRow,
  CCol,
  CLabel,
  CSelect
} from "@coreui/react";

const EduLevel = (props) => {
  const { eduLevelList, handleInputChange } = props;
  const { insert, main } = useSelector((state) => state);

  return (
    <>
      <CRow>
        <CCol xs="12" md="6" className="text-left mb-2">
          <CLabel>
            <span>*</span>학력
          </CLabel>
          <CSelect 
              custom
              id="eduLevel"
              name="eduLevel"
              value={insert.reqTaskInfo.eduLevel || ""} 
              onChange={handleInputChange}
              disabled={
                insert.reqTaskInfo.stCd === "10" ||
                insert.reqTaskInfo.stCd === "99"
                  ? false
                  : true
              }
              >
            <option value="">선택</option> 
             {eduLevelList.map((level) => (
              <option key={level.DTL_CD} value={level.DTL_CD}>
                {level.CD_NM}
              </option>
            ))}
          </CSelect>
        </CCol>
      </CRow>
    </>
  )
}

export default React.memo(EduLevel);